/**
 * @generated SignedSource<<cc5bb5c5c548b3969d8170998404f9d7>>
 * @relayHash 11fc70549ecffc4e4357e863934125f1
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/560.0.0-2026-05-20T21:10:43.265Z/useFetchDesignProjectPhotosQuery

import { ConcreteRequest } from 'relay-runtime';
export type useFetchDesignProjectPhotosQuery$variables = {
  projectRootId: string;
};
export type useFetchDesignProjectPhotosQuery$data = {
  readonly viewer: {
    readonly designProjectRootSearch: {
      readonly tradePhotos: ReadonlyArray<{
        readonly height: number | null;
        readonly name: string | null;
        readonly path: string | null;
        readonly serviceId: string | null;
        readonly url: string | null;
        readonly width: number | null;
      } | null> | null;
    } | null;
  };
};
export type useFetchDesignProjectPhotosQuery = {
  response: useFetchDesignProjectPhotosQuery$data;
  variables: useFetchDesignProjectPhotosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectRootId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "projectRootId",
    "variableName": "projectRootId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFetchDesignProjectPhotosQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "DesignProjectRootSearchResult",
            "kind": "LinkedField",
            "name": "designProjectRootSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TradePhoto",
                "kind": "LinkedField",
                "name": "tradePhotos",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchDesignProjectPhotosQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "DesignProjectRootSearchResult",
            "kind": "LinkedField",
            "name": "designProjectRootSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TradePhoto",
                "kind": "LinkedField",
                "name": "tradePhotos",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/560.0.0-2026-05-20T21:10:43.265Z/useFetchDesignProjectPhotosQuery",
    "metadata": {},
    "name": "useFetchDesignProjectPhotosQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "73ac6ad0c6910f3b7d8d39edb9b1d6d0";

export default node;
